<h1 class="c:blue-700">Deine Verträge</h1>
<div class="contract-list-container">
    <app-contract-list
        [contracts]="contracts()"
        route="/portal/meine-vertraege/:contractId"
    />
</div>
